<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import AnimatedBackground from '../../AnimatedBackground.vue'
import CharacterJumpFromTheRight from '../kijk_live_qmusic_nl_default/text_animations/CharacterJumpFromTheRight.vue'
import { cdnImageUrl } from '@dpgradio/creative'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import ChartTrackRow from './shared/ChartTrackRow.vue'
import useChart from '../../../composables/useChart.js'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const colorScheme = {
  current: {
    backgroundColor: '#fff',
    color: colors.q.cr.gray.lighter,
  },
  other: {
    backgroundColor: colors.q.cr.gray.primary,
    color: colors.q.cr.gray.darker,
  },
}

const listTitleElement = ref(null)
const listImageElement = ref(null)
const trackElements = ref(null)
const trackListContainerElement = ref(null)

const { chart, tracks, currentPosition } = useChart(props, 4)

onMounted(() => {
  if (!tracks.value) {
    return
  }
  const currentIndex = Object.values(tracks.value).findIndex((track) => track.position === currentPosition.value)
  if (currentIndex === -1) {
    return
  }
  const allTrackElementsExceptCurrent = Array.from(trackElements.value).filter((item, index) => index !== currentIndex)
  gsapTimeline({ name: 'ChartPosition', delay: 1 })
    .set(allTrackElementsExceptCurrent, { height: 0, overflow: 'hidden' })
    .from(listTitleElement.value, { opacity: 0, y: 100, duration: frames(12), ease: 'back.out(1.4)' })
    .from(listImageElement.value, { opacity: 0, y: 100, duration: frames(12), ease: 'back.out(1.4)' }, `<${frames(4)}`)
    .from(trackListContainerElement.value, { scale: 0, rotationY: 25, duration: frames(8), ease: 'back.out' }, `=-${frames(4)}`)
    .to(allTrackElementsExceptCurrent, { height: 'auto', duration: frames(12), ease: 'power2.out' }, `+=${frames(30)}`)
})
</script>

<template>
  <ToFullBottomRight>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :scale="3" :position="{ x: -1200, y: 900 }" :backgroundColor="colors.q.cr.gray.primary" :color="colors.q.cr.gray.darker" class="pt-48">
      <div v-if="chart" class="flex gap-28 -center px-safe">
        <div class="w-2/5">
          <div ref="listTitleElement" class="text-9xl tracking-tight text-white font-cervo font-bold mb-8">{{ chart.editionName }}</div>
          <img v-if="chart.listImage" ref="listImageElement" :src="cdnImageUrl(chart.listImage, 'w1200')" class="rounded-[4rem] w-full" />
        </div>
        <div class="flex-1 h-[44rem] flex flex-col justify-center">
          <div v-if="tracks" ref="trackListContainerElement" class="flex flex-col rounded-2xl bg-white overflow-hidden relative">
            <div>
              <div v-for="(track, position) in tracks" ref="trackElements" :key="position" class="relative z-[5]">
                <ChartTrackRow
                  :track="track"
                  :position="position"
                  :currentPosition="currentPosition"
                  :chart="chart"
                  rowClass="h-44 p-6 pr-8 gap-6"
                  textClass="text-[3.3rem]"
                  positionClass="text-7xl"
                  movementClass="text-4xl -mb-6"
                  :placeholderClass="['h-12 w-96', 'h-10 w-60']"
                />
              </div>
            </div>
            <div class="absolute z-0 bottom-0 left-0 w-full h-[44rem] overflow-hidden opacity-40">
              <AnimatedBackground :lottie="PositiveWaveLoop1" :backgroundColor="colorScheme.current.backgroundColor" :color="colorScheme.current.color" :scale="4" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex items-center justify-center size-full text-white">
        <div class="flex flex-col items-center">
          <TextSlideUp text="Nu op Q" class="text-8xl mb-8" />
          <CharacterJumpFromTheRight :text="item.enrichment.program?.title" textSizeClass="text-[12em]" textOutlineSizeClass="text-[12.6em]" />
        </div>
      </div>
    </AnimatedBackground>
  </ToFullBottomRight>
</template>
